import { render, staticRenderFns } from "./IconCustservice.vue?vue&type=template&id=75eb2ed8&"
import script from "./IconCustservice.vue?vue&type=script&lang=js&"
export * from "./IconCustservice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports